$mol_icon_menu_up $mol_icon path \M7,15L12,10L17,15H7Z
